<template>
  <div>
    <div v-if="plans.init === 1">
      <v-layout row wrap class="mb-4">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" v-if="showReview" @click.prevent="promptReselect = true">
          Re-select Plan
          <v-icon right>mdi-pencil</v-icon>
        </v-btn>
      </v-layout>
      <transition name="slide-x-transition" mode="out-in">
        <review-plan v-if="showReview" :paType="paForm.paType" :plan="$store.getters.paQuoteSelectedPlan" :limitsText="compileLimitsText" :reviewPlanParam="$store.state.agency.quotation.paParam.reviewPlan" recalcMethodName="paQuoteRecalculate" @proceed="doProceedReview"></review-plan>
        <div v-else>
          <template v-if="plans.plans.length > 0">
            <v-tabs icons-and-text centered v-model="paForm.paType">
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab href="#I" v-if="individualPlans.length > 0" key="I">
                Individual
                <v-icon>mdi-account</v-icon>
              </v-tab>
              <v-tab href="#F" v-if="familyPlans.length > 0" key="F">
                Family
                <v-icon>mdi-account-group</v-icon>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="paForm.paType">
              <v-tab-item value="I" v-if="individualPlans.length > 0" key="I">
                <common-plans :plans="individualPlans" :limitsText="compileLimitsText" :selected="paForm.planNo" :currPrefix="currPrefix" iconType="PA" @selectPlan="doSelectPlan"></common-plans>
              </v-tab-item>
              <v-tab-item value="F" v-if="familyPlans.length > 0" key="F">
                <common-plans :plans="familyPlans" :limitsText="compileLimitsText" :selected="paForm.planNo" :currPrefix="currPrefix" iconType="PA" @selectPlan="doSelectPlan"></common-plans>
              </v-tab-item>
            </v-tabs-items>
          </template>
          <template v-else>
            <common-plans :plans="plans.plans" :limitsText="compileLimitsText" :selected="paForm.planNo" :currPrefix="currPrefix" iconType="PA" @selectPlan="doSelectPlan"></common-plans>
          </template>
        </div>
      </transition>
      <v-layout row wrap class="mt-3">
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <v-layout wrap row align-center class="v-label theme--light">
                <v-flex sm6 xs12>
                  Optional Cover
                </v-flex>
                <v-flex sm6 xs12 fill-height>
                  Sum Insured
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap align-center v-for="optCvr in optionalCovers" :key="optCvr.riskNo + '-' + optCvr.itemNo + '-' + optCvr.paType">
                <v-flex sm6 xs12 class="ma-0 pa-0">
                  <v-checkbox class="pt-3" v-model="tempForm.optCvrs" :label="optCvr.description" :value="optCvr.riskNo + '-' + optCvr.itemNo + '-' + optCvr.paType"
                    @change="recalculate" :readonly="showReview"/>
                </v-flex>
                <v-flex sm6 class="ma-0 pa-0" fill-height>
                  <div class="v-label theme--light">{{'S$' + formatDisplayNumber(optCvr.minSI)}}</div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="mt-3">
        <v-flex xs12>
          <v-card>
            <v-card-title class="v-label theme--light">
              Top-up Cover
            </v-card-title>
            <v-card-text>
              <v-layout row wrap align-center v-for="optCvr in topUpCovers" :key="optCvr.riskNo + '-' + optCvr.itemNo + '-' + optCvr.paType">
                <v-flex sm6 xs12 fill-height>
                  <div>{{optCvr.description}}</div>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-slider v-model="tempForm.optCvrSI[optCvr.riskNo + '-' + optCvr.itemNo + '-' + optCvr.paType]" always-dirty :hint="'Sum Insured: S$' + formatDisplayNumber(tempForm.optCvrSI[optCvr.riskNo + '-' + optCvr.itemNo + '-' + optCvr.paType])"
                    persistent-hint thumb-label="always" :thumb-size="30" :min="optCvr.minSI" :max="optCvr.maxSI" :step="optCvr.incSI" @change="recalculate"
                    :readonly="showReview"/>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <confirm v-model="promptReselect" @ok="doReselectPlan">
        Are you sure you want to re-select plan? Any plan adjustment will be discarded.
      </confirm>
      <v-layout row wrap class="mt-3">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-layout>
    </div>
    <div v-else>
      <v-layout row wrap class="mb-4">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-layout>
      <loader :height="425" :init="doInit" :errorMsgs="plans.initErr" loadText="Loading Plans..." errorText="Failed to load Plans" :loading="plans.init === 0"></loader>
      <v-layout row wrap class="mt-3">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-layout>
    </div>
    <v-dialog v-model="recalculating" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Recalculating. Please wait..
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import clone from 'clone'
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_PA_PLANS, QUOTE_PA_ADJ_CANCEL, QUOTE_PA_OPT_CVRS } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import CommonPlans from '../../shared/plans/CommonPlans'
import ReviewPlan from '../../shared/plans/ReviewPlan'
import { formatDisplayNumber } from '@/utils/number'

export default {
  data() {
    return {
      paForm: {
        planNo: undefined,
        paType: undefined
      },
      tempForm: {
        optCvrs: [],
        optCvrSI: {},
        paType: undefined
      },
      showReview: false,
      promptReselect: false,
      recalculating: false
    }
  },
  watch: {
    'paParam.optCvrs': function (value) {
      this.initializeOptCvrs()
    }
  },
  computed: {
    paParam() {
      return this.$store.state.agency.quotation.paParam
    },
    optionalCovers() {
      return this.paParam.optCvrs.filter(x => x.allowSI === false && x.paType === this.paForm.paType)
    },
    topUpCovers() {
      return this.paParam.optCvrs.filter(x => x.allowSI === true && x.paType === this.paForm.paType)
    },
    plans() {
      return this.paParam.plans
    },
    individualPlans() {
      let result = []
      if (this.plans.plans && this.plans.plans.length > 0) {
        result = this.plans.plans.filter(x => x.subPlan === 'I')
      }
      return result
    },
    familyPlans() {
      let result = []
      if (this.plans.plans && this.plans.plans.length > 0) {
        result = this.plans.plans.filter(x => x.subPlan === 'F')
      }
      return result
    },
    compileLimitsText() {
      // Need give the main row a main attribute (appearance tweak)
      const result = clone(this.plans.limitsText)
      for (const limit of result) {
        if (limit.value.indexOf('.') === -1) {
          limit.main = true
        }
      }
      return result
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    },
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    globalPAForm() {
      return this.$store.state.agency.quotation.paForm
    }
  },
  methods: {
    doInit() {
      if (this.plans.init !== 1) {
        this.$store.dispatch('paQuotePlans')
      }
      this.paForm.planNo = this.globalPAForm.planNo
      this.paForm.paType = this.globalPAForm.paType

      if (this.paForm.planNo) {
        this.showReview = true
      }
      this.initializeOptCvrs()
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
      this.$router.push({ name: 'paQuote' })
    },
    doSelectPlan(obj) {
      if (obj) {
        this.$store.commit(QUOTE_PA_OPT_CVRS, this.tempForm)
        this.paForm.planNo = obj.value
        if (obj.proceed) {
          this.doProceed()
        }
      }
    },
    doReselectPlan() {
      this.showReview = false
      this.promptReselect = false
      this.$store.commit(QUOTE_PA_ADJ_CANCEL)
      this.paForm.planNo = null
    },
    doProceed() {
      if (this.paForm.planNo) {
        this.$store.commit(QUOTE_PA_PLANS, this.paForm)
        this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
        this.$router.push({ name: 'paQuoteApplicant' })
      } else {
        this.$snotify.error('Please select a Plan')
      }
    },
    doProceedReview() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
      this.$router.push({ name: 'paQuoteApplicant' })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        // No need commit planNo for save
        // this.$store.commit(QUOTE_PA_PLANS, this.paForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    },
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    },
    initializeOptCvrs() {
      const optCvrsMap = {}
      for (let optCvr of this.commonForm.optCvr) {
        optCvrsMap[optCvr.riskNo + '-' + optCvr.itemNo + '-' + optCvr.paType] = optCvr.si || true
      }
      let topUpCovers = this.paParam.optCvrs.filter(x => x.allowSI === true)
      for (let topUpCvr of topUpCovers) {
        if (optCvrsMap[topUpCvr.riskNo + '-' + topUpCvr.itemNo + '-' + topUpCvr.paType]) {
          this.tempForm.optCvrSI[topUpCvr.riskNo + '-' + topUpCvr.itemNo + '-' + topUpCvr.paType] = optCvrsMap[topUpCvr.riskNo + '-' + topUpCvr.itemNo + '-' + topUpCvr.paType]
        } else {
          this.tempForm.optCvrSI[topUpCvr.riskNo + '-' + topUpCvr.itemNo + '-' + topUpCvr.paType] = topUpCvr.minSI || 0
        }
      }
      let optionalCovers = this.paParam.optCvrs.filter(x => x.allowSI === false)
      let selectedOptCvrs = []
      for (let optCvr of optionalCovers) {
        if (optCvrsMap[optCvr.riskNo + '-' + optCvr.itemNo + '-' + optCvr.paType]) {
          selectedOptCvrs.push(optCvr.riskNo + '-' + optCvr.itemNo + '-' + optCvr.paType)
        }
      }
      this.tempForm.optCvrs = selectedOptCvrs
    },
    async recalculate() {
      this.recalculating = true
      this.$store.commit(QUOTE_PA_OPT_CVRS, this.tempForm)
      await this.$store.dispatch('paOptCvrRecalculate')
      this.recalculating = false
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 2) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
    }
    this.doInit()
  },
  components: {
    CommonPlans,
    ReviewPlan
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">
</style>
